import { render } from "./MenuAccordion.vue?vue&type=template&id=2db8cf97"
import script from "./MenuAccordion.vue?vue&type=script&lang=js"
export * from "./MenuAccordion.vue?vue&type=script&lang=js"
script.render = render

export default script